import styled from "styled-components";
const MyDiv = styled.div`
  .card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    background: #ffffff;
  }

  .imageRow {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .imageRow::-webkit-scrollbar {
    display: none;
  }

  .imageBox {
    width: 350px;
    height: 300px;
    border-radius: 10px;
    overflow: hidden;
    flex-shrink: 0;
    position: relative;
  }

  .imageBox img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }


  .imageHover {
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    gap: 6px;
    opacity: 1;         
    pointer-events: auto;
    z-index: 2;
  }

  .deleteBtn {
    background: #ef4444 !important;
    color: #fff !important;
  }

  .checkBtn {
    background: #22c55e !important;
    color: #fff !important;
  }
`;

export default MyDiv;
